import { Component, OnDestroy } from '@angular/core';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SortPipe } from '@core';
import { MultipleSelectComponent, SearchInputComponent } from '@ui';

import { BuildingDataFilterService } from '../../../services/building-data-filter.service';

@Component({
  selector: 'app-site-table-desktop-filters',
  templateUrl: './site-table-desktop-filters.component.html',
  imports: [
    MatButtonToggleGroup,
    MatButtonToggle,
    SearchInputComponent,
    MatIcon,
    MatOption,
    MatSelectModule,
    MatSuffix,
    MatFormField,
    MultipleSelectComponent,
    MatButton,
    SortPipe,
],
})
export class SiteTableDesktopFiltersComponent implements OnDestroy {
  constructor(public buildingDataFilterService: BuildingDataFilterService) { }

  get selectedFilters(): boolean {
    return !!(this.buildingDataFilterService.statusFilter || this.buildingDataFilterService.incidentFilter?.length);
  }

  clearAllFilters() {
    this.buildingDataFilterService.statusFilter = '';
    this.buildingDataFilterService.incidentFilter = [];
  }

  ngOnDestroy() {
    this.buildingDataFilterService.clearFilters();
  }
}
